import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist';
import user from "@/store/modules/user";
import {decode, encode} from "@/assets/Js/base64";
import dict from "@/store/modules/dict";
import permission from "@/store/modules/permission";
import breadcrumb from "@/store/modules/breadcrumb";
import getters from "@/store/getters";

const vuexLocal = new VuexPersistence({
    key: "medical-cli-platform",
    storage: {
         /*getItem: key => decode(window.sessionStorage.getItem(key)),
        setItem: (key, value) => window.sessionStorage.setItem(key,encode(value)),*/
        getItem: key => window.sessionStorage.getItem(key),
        setItem: (key, value) => window.sessionStorage.setItem(key,value),
        removeItem: (key) => window.sessionStorage.removeItem(key) // 删除
    },
    modules: [user],
    reducer(val) {
        return {
            user: {
                token: val.user.token,
                userId: val.user.userId,
                userName: val.user.userName,
                nickName: val.user.nickName,
                operator: val.user.operator,
                avatar: val.user.avatar,
                isAdmin: val.user.isAdmin,
            }
        }
    },
})

export default createStore({
    modules: {
        user,
        dict,
        breadcrumb,
        permission
    },
    getters,
    plugins: [vuexLocal.plugin]
})
